import { addMinutes } from 'date-fns';
import { slotFitsEmployeeSchedule } from '../../../shared/booking/employee-schedule/workingSchedule';

export function resolveStorefrontChosenEmployee({
  staff,
  availableStaff,
  date,
  time,
  companyHours,
  getTotalDurationMinutes,
}) {
  if (!staff || !date || !time || typeof getTotalDurationMinutes !== 'function') {
    return null;
  }
  const bookingDuration = getTotalDurationMinutes();
  const hours = companyHours || {};
  return staff.isAnyAvailable
    ? availableStaff.find(
        (employee) =>
          !employee.isAnyAvailable &&
          slotFitsEmployeeSchedule({
            workingSchedule: employee.workingSchedule,
            date,
            slotStart: time,
            slotEnd: addMinutes(time, bookingDuration),
            companyHours: hours,
          })
      )
    : staff;
}
